import $ from 'jquery';

export default function accordions() {
  $('.accordion__item .accordion__item__question').click(function() {
    $(this).parent().toggleClass('is-open');
  });
}